<template>
    <div>
      <!-- <h1>不分页 数量不大</h1> -->
      <div class="title">
      <span>发表论文</span>
    </div>
      <div class="serch">
        <el-form :inline="true" :model="form" >
          <el-form-item label="Title">
            <el-input v-model="form.title" placeholder="Input title"></el-input>
          </el-form-item>
          <el-form-item label="Author">
            <el-input v-model="form.author" placeholder="Input author"></el-input>
          </el-form-item>
          <!-- <el-form-item label="Select year">
            <el-date-picker
              v-model='form.year'
              type="year"
              placeholder="Year">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="onSubmit">Search</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 暂定为不分页页面 -->
      <div class="list">
        <div class="item" v-for="(item,index) in publicationList" :key="index">
          <div class="left">
            <h3>{{ item.title}}</h3>
            <p>Author: {{ item.author}}<br/><br/>{{ item.publishJournals}}</p>
            <p><a :href="item.linkUrl">{{ item.linkName}}</a></p>
          </div>
          <div class="right">
             <el-image
                style="width: 300px; height: 200px"
                :src="item.image"
                fit="cover"
              >
            </el-image>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import {listPublication} from '@/api/api'
export default {
  data () {
    return {
      form: {
      },
      publicationList: []
    }
  },
  created () {
    this.listPublication()
  },
  methods: {
    onSubmit () {
      this.listPublication()
    },
    listPublication () {
      listPublication(this.form).then(res => {
        if (res.code === 200) {
          let item = res.data.sort((a, b) => {
            return b.sortNum - a.sortNum
          })
          this.publicationList = item
        }
      })
    }
  }
}
</script>

  <style scoped>
.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
.serch {
  margin-top: 20px;
}
.list {
}
.item {
  /* height: 300px; */
   display: flex;
   padding: 10px;
   justify-content: space-between;
   border-bottom: 1px solid #2f4f4f;
   box-sizing: border-box;
}
.item .left{
  flex-grow: 1;
}
.item .right{
  flex-shrink: 0;
}
.item p {
  font-size: 13px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/view/publications.vue